import { render, staticRenderFns } from "./InvoicesTab.vue?vue&type=template&id=985cfa3e&"
import script from "./InvoicesTab.vue?vue&type=script&lang=js&"
export * from "./InvoicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('985cfa3e')) {
      api.createRecord('985cfa3e', component.options)
    } else {
      api.reload('985cfa3e', component.options)
    }
    module.hot.accept("./InvoicesTab.vue?vue&type=template&id=985cfa3e&", function () {
      api.rerender('985cfa3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/customization-tabs/InvoicesTab.vue"
export default component.exports